// Importar el nuevo servicio API
import { loadAvailableSongs as loadSongsFromAPI } from '../services/apiService';

// Lista legacy para compatibilidad (ya no se usa activamente)
export const songsList = [
  "Jósean Log - La Luna .mp3",
  "Jorge Drexler - Eco.mp3",
  "Jorge Drexler - Don de fluir.mp3",
  "♪ Limp bizkit - Take a look around.mp3",
  "Radiohead - Weird Fishes.mp3",
];

// Función actualizada que obtiene canciones del backend
export const loadAvailableSongs = loadSongsFromAPI;
